const roomTypeUpgrade = [
  'twinShare',
  'triple',
  'tripleShare',
  'quad',
  'quadShare',
  'multiShare',
]

export function hasRoomTypeUpgrade(roomType: Tours.V2OfferRoomType | undefined) {
  return roomTypeUpgrade.includes(roomType ?? '')
}
